import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import themeColors, { themeFontSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    container: {
        gap: 0,
        css: css`
            &.grid-control {
                select[data-test-selector="paginationPerPageSelect"],
                select[data-test-selector="productListSortSelect"] {
                    color: ${themeColors.colorSelectBox} !important;
                    font-family: Roboto;
                    font-size: ${themeFontSizes.size14};
                    border: 1px solid ${themeColors.colorBorderBrands} !important;
                    border-radius: 2px !important;
                    background-color: ${themeColors.colorWhite} !important;
                }
            }
        `,
    },

    // Row 1 – Results per page
    countGridItem: { width: [12, 12, 12, 12, 12] },
    countTableViewGridItem: { width: [12, 12, 12, 12, 12] },

    // Row 2 – Jump to page + Sort by (new line, let widget align itself)
    sortGridItem: { width: [12, 12, 12, 12, 12] },
    sortTableViewGridItem: { width: [12, 12, 12, 12, 12] },

    // Row 3 – View toggle
    viewSelectGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
        border:1px solid #F00 !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`display: none;`,
                    css`display: none;`,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    viewSelectTableViewGridItem: { width: [12, 12, 12, 12, 12] },
};

const styles = controlsContainerStyles;

const ProductListControlsContainer: FC<Props> = ({ id, view }) => {
    return (
        <GridContainer {...styles.container} className="grid-control">
            {/* - The original two grid items no longer necessary due to combined controls widget, but leaving commented in place for easier future adjustments if needed.
            <GridItem {...(view === "Table" ? styles.countTableViewGridItem : styles.countGridItem)}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>

            <GridItem {...(view === "Table" ? styles.sortTableViewGridItem : styles.sortGridItem)}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
            */}
            
            <GridItem {...(view === "Table" ? styles.viewSelectTableViewGridItem : styles.viewSelectGridItem)}>
                <Zone contentId={id} zoneName="Content03" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: [ProductListPageContext],
    },
};

export default widgetModule;